"use client";
import "@/app/style/speedpro.scss";

import { LANGUAGE, str2LangCode, useLanguage } from '@/app/utils/LanguageContext';
import { getSearchParams, setRouting, switchLanguage, getAssetPrefix, adobeData, getCmsDomain, updateMetaTag, isUrlExisted } from '@/app/utils/Common';
import { usePathname } from 'next/navigation'
import { useEffect, useState } from "react";
import { getSpeedguide } from "@/app/utils/request/requestList";
import { PageContext } from '@/app/ui/SpeedPro/PageContext';
import Footer from "@/app/ui/footer";
import { pageSet } from "@/app/utils/pageSet";

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const { state: lang } = useLanguage();
  const { t } = lang;
  const [raceData, setRaceData] = useState<any>(null);
  const [raceInfo, setRaceInfo] = useState<any>();
  const [displayEmpty, setDisplayEmpty] = useState<boolean>(false);
  const [bannerSrc, setBannerSrc] = useState<string>();

  const pathname = usePathname()?.split("/")?.pop()?.toLowerCase() ?? "speedguide";
  const { raceno } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search));
  const assetPrefix = getAssetPrefix();

  const handleChangeLang = () => {
    Object.keys(LANGUAGE).map((key: string) => {
      const code = str2LangCode(key)
      if (lang.langCode === code) return

      switchLanguage(code);
    });
  }

  const handleChangeRace = (raceNo: string) => {
    setRouting(undefined, { "raceno": raceNo });
  }

  useEffect(() => {
    updateMetaTag(lang.langCode, pageSet[pathname == "formguide" ? "formguide" : "speedguide"]);

    adobeData(lang.langCode, "pageview", {
      pageId: "racing/local",
    });

    getSpeedguide({}).then((res: any) => {
      setRaceInfo(res);
      setRaceData(res?.[lang.langCode] || []);

      const neverExpire = window?.globalConfig?.OTHERS?.SPEED_PRO_NEVER_EXPIRE == "Y"; // ignore expire date checking in SIT
      if (!res?.[lang.langCode]?.length) {
        setDisplayEmpty(true);
      } else if (res?.expiredate && !neverExpire) {
        const now = new Date();
        const expDate = new Date(res?.expiredate);
        // show no info when expiry date past
        if (now > expDate) {
          setDisplayEmpty(true);
        }
      }
      if (!res?.[lang.langCode]?.find(((x: any) => x.race == (raceno ?? 1)))) {
        setDisplayEmpty(true)
      }
    });

    const banner = `${getCmsDomain()}/-/media/Sites/JCRW/SpeedPro/header/SpeedPRO_top_bar_${lang.langType}`;
    validateImageUrl(banner);
  }, []);

  const validateImageUrl = async (url: any) => {
    await isUrlExisted(url).then(isValid => {
      if (isValid) {
        setBannerSrc(url);
        console.log('set banner path', url)
      } else {
        setBannerSrc(`${assetPrefix}/speedpro/SpeedPRO_top_bar_${lang.langType}.jpg`);
      }
    }).catch((_) => {
      setBannerSrc(`${assetPrefix}/speedpro/SpeedPRO_top_bar_${lang.langType}.jpg`);
    });
  };
  
  function waTracker(lang: any, eventId: string) {
    console.log('tracker name: ', eventId);
    adobeData(lang.langCode, "interaction", {
      pageId: "racing/local", eventId: eventId,
    });
  }

  return (
    pathname == "tutorial" ?
      <div>{children}</div> :
      <div className="container">
        <meta name="viewport" content="width=device-width"/>
        <div>
          <div className="top">
            <img className="top-img" src={bannerSrc} />
            <div className='changelang' onClick={handleChangeLang}></div>
            <a href='//bet.hkjc.com/index.aspx?lang=ch' className='ewin' target="_blank" onClick={(e) => waTracker(lang, 'header_ewin_home')}></a>
          </div>
          <ul className="main-nav">
            <li><a href="formguide">{t("FormGuide")}</a></li>
            <li><a href="speedguide">{t("SpeedGuide")}</a></li>
            <li><a href={`//common.hkjc.com/utility/faq/${lang.langType}/racing/speedpower`} target="_blank">{t("FAQ")}</a></li>
            <li className="last_update"><span style={{ "whiteSpace": "nowrap" }} className="last_update_data">{!displayEmpty && raceInfo?.lastupdatetime ? `${t("last_update_time")}: ${raceInfo?.lastupdatetime}` : ""}</span></li>
          </ul>
        </div>
        {
          raceData?.length && !displayEmpty ?
            <div className="race-data">
              <div className="header">
                <div className="date">{raceInfo.racedate?.slice(0, 10)}</div>
                <div className={`title${lang.langType == "english" ? "-en" : ""}`}>{pathname == "formguide" ? t("FormGuide") : t("SpeedGuide")}</div>
              </div>
              <div>
                <ul className="race-nav">
                  <li><img src={`${assetPrefix}/speedpro/racearrow.gif`} />{t("LocalRace")}</li>
                  {raceData.map((race: any) => <li key={`raceNav_` + race.race} className={race.race == raceno ? "select" : ""}><a onClick={() => handleChangeRace(race.race)}>{t("RaceNoFormat").replace("{0}", race.race)}</a></li>)}
                </ul>
              </div>
              <PageContext.Provider value={raceInfo}>
                {children}
              </PageContext.Provider>
            </div> :
            <div className="no-data"><p>{raceData == null ? t("loadingMsg") : t("NoData")}</p></div>
        }
        <Footer />
      </div>
  );
}
